import {z} from "zod";

const fileOrUploadedUrl = z.union([z.string().min(1), z.custom<File>((v) => v instanceof File)]);

export const storedVehicleCreateFormSchema = z.object({
  vehicle_id: z.number({required_error: "Vehicle is required"}).min(1, "Vehicle is required"),
  description: z
    .string()
    .trim()
    .min(1, "Description is required")
    .max(5000, "Description must be at most 5000 characters"),
  private_notes: z.string().max(5000).optional(),
  gps_coordinates: z.string().trim().optional(),
  files: z.array(fileOrUploadedUrl).min(1, "At least one image is required"),
});

export const storedVehicleCancelSchema = z.object({
  cancellation_reason: z
    .string()
    .trim()
    .min(1, "Cancellation reason is required")
    .max(5000, "Cancellation reason must be at most 5000 characters"),
  files: z.array(fileOrUploadedUrl),
});

export const storedVehicleFollowUpSchema = z.object({
  notes: z
    .string()
    .trim()
    .min(1, "Notes are required")
    .max(5000, "Notes must be at most 5000 characters"),
  files: z.array(fileOrUploadedUrl).min(1, "At least one image is required"),
});

export type StoredVehicleCreateFormValues = z.infer<typeof storedVehicleCreateFormSchema>;
export type StoredVehicleCancelFormValues = z.infer<typeof storedVehicleCancelSchema>;
export type StoredVehicleFollowUpFormValues = z.infer<typeof storedVehicleFollowUpSchema>;
